import {NewBookingInfo} from './bosch/model/bosch-booking.info';

export const appendReservationLink = (newBooking: NewBookingInfo, translations: any, comments: string): string => {
  let reservationLink = translations.parkingBooking.form.reservationLink + newBooking.reservationLink;
  return comments?.length > 0 ? (comments + '\n-----------------\n' + reservationLink) : reservationLink;
}
